import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { UserOutlined } from "@ant-design/icons";
import { Button, Popover } from "antd";
import authActions from "../../../redux/auth/actions";
import "../index.css";

const { logout } = authActions;

function HeaderUserProfile() {
  const [openPopover, setOpenPopover] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const fullName = localStorage.getItem("fullName");

  const handleLogoutClick = () => {
    dispatch(logout());
    localStorage.clear();
    navigate("/signin");
  };

  const content = (
    <div className="header-profile">
      <Button id="header-profile-buttons" onClick={handleLogoutClick}>
        Изход
      </Button>
    </div>
  );

  const handleOpenChange = (newOpen) => {
    setOpenPopover(newOpen);
  };

  return (
    <Popover
      content={content}
      title={<p className="header-profile-title">Здравейте, {fullName}</p>}
      trigger="click"
      open={openPopover}
      onOpenChange={handleOpenChange}
    >
      <UserOutlined style={{ fontSize: "25px" }} />
    </Popover>
  );
}

export default HeaderUserProfile;
